define((require) => {
    "use strict";

    const _ = require("underscore");
    const AbstractWidgetModel = require("shared/ui/experience/widgets/AbstractWidgetModel");
    const CompositeWidgetModel = require("shared/ui/experience/widgets/compositeWidget/CompositeWidgetModel");

    /**
     * Model for a dynamic product widget.
     *
     * @class DynamicProductWidgetModel
     * @constructor
     */
    return CompositeWidgetModel.extend("DynamicProductWidgetModel", {
        defaults: _.defaults({
            type: "dynamic-product",
            subtype: "",
            productID: "",
            dynamicSubwidgetLookup: null
        }, AbstractWidgetModel.prototype.defaults),

        initialize() {
            // When layer index is updated, make sure subwidgets are
            // all still selectable by setting their index to be 1 higher
            // than the parent's.
            this.on("change:layerIndex", (model) => {
                if (this.has("group")) {
                    this.get("group").forEach((widget) => {
                        widget.set("layerIndex", model.get("layerIndex") + 1);
                    });
                }
            });
        },

        setProductID(productID) {
            this.set("productID", productID);
        },

        setInputProductID(inputID) {
            this.set("inputProductID", inputID);
        },

        _scaleGroup(scale) {
            if (this.get("group")) {
                this.get("group").invoke("set", "scale", scale);
            }
        },

        setDynamicSubwidgetLookup(dynamicSubwidgetLookup) {
            this.set("dynamicSubwidgetLookup", dynamicSubwidgetLookup);
        },

        setGroup(subwidgets) {
            this.set("group", subwidgets);
        }

    });
});



// WEBPACK FOOTER //
// ./src/shared/ui/experience/widgets/dynamicProductWidget/DynamicProductWidgetModel.js